import React, { useState } from 'react';
import styled from 'styled-components';

// Icons for file types
import notepadIcon from 'assets/windowsIcons/327(16x16).png';
import excelIcon from 'assets/windowsIcons/excel-icon.svg';
import calendarIcon from 'assets/windowsIcons/308(16x16).png';
import folderIcon from 'assets/windowsIcons/308(16x16).png';

const DOCUMENTS = [
  { name: 'passwords.txt', icon: notepadIcon, type: 'Text Document', size: '1 KB', app: 'passwords.txt' },
  { name: 'Security Checklist.rtf', icon: notepadIcon, type: 'Rich Text Document', size: '4 KB', app: 'Security Checklist' },
  { name: 'My Finances.xls', icon: excelIcon, type: 'Microsoft Excel Worksheet', size: '24 KB', app: 'My Finances.xls' },
  { name: 'TAX DEADLINES.txt', icon: notepadIcon, type: 'Text Document', size: '2 KB', app: 'Sticky Notes' },
  { name: 'Compliance Calendar', icon: calendarIcon, type: 'Calendar File', size: '8 KB', app: 'Compliance Calendar' },
  { name: 'Client Reviews', icon: folderIcon, type: 'Folder', size: '', app: 'Testimonials' },
];

function MyDocuments() {
  const [selectedIdx, setSelectedIdx] = useState(-1);

  function handleDoubleClick(doc) {
    // Dispatch custom event — parent (WinXP) listens for this and opens the app
    window.dispatchEvent(new CustomEvent('xp-open-app', { detail: doc.app }));
  }

  return (
    <Container>
      <div className="md__toolbar">
        <div className="md__toolbar__title">My Documents</div>
        <div className="md__toolbar__path">
          C:\Documents and Settings\User\My Documents
        </div>
      </div>
      <div className="md__body">
        <div className="md__sidebar">
          <div className="md__sidebar__section">
            <div className="md__sidebar__title">File and Folder Tasks</div>
            <div className="md__sidebar__link">Make a new folder</div>
            <div className="md__sidebar__link">Publish this folder to the Web</div>
            <div className="md__sidebar__link">Share this folder</div>
          </div>
          <div className="md__sidebar__section">
            <div className="md__sidebar__title">Other Places</div>
            <div className="md__sidebar__link">Desktop</div>
            <div className="md__sidebar__link">My Computer</div>
            <div className="md__sidebar__link">My Network Places</div>
          </div>
          <div className="md__sidebar__section">
            <div className="md__sidebar__title">Details</div>
            <div className="md__sidebar__info">
              {selectedIdx >= 0 ? (
                <>
                  <strong>{DOCUMENTS[selectedIdx].name}</strong>
                  <br />
                  Type: {DOCUMENTS[selectedIdx].type}
                  <br />
                  {DOCUMENTS[selectedIdx].size && `Size: ${DOCUMENTS[selectedIdx].size}`}
                </>
              ) : (
                <>
                  <strong>My Documents</strong>
                  <br />
                  {DOCUMENTS.length} items
                </>
              )}
            </div>
          </div>
        </div>
        <div className="md__content">
          <div className="md__header__row">
            <span className="md__col md__col--name">Name</span>
            <span className="md__col md__col--type">Type</span>
            <span className="md__col md__col--size">Size</span>
          </div>
          <div className="md__list">
            {DOCUMENTS.map((doc, i) => (
              <div
                key={doc.name}
                className={`md__item ${selectedIdx === i ? 'md__item--selected' : ''}`}
                onClick={() => setSelectedIdx(i)}
                onDoubleClick={() => handleDoubleClick(doc)}
              >
                <span className="md__col md__col--name">
                  <img src={doc.icon} alt="" className="md__file__icon" />
                  {doc.name}
                </span>
                <span className="md__col md__col--type">{doc.type}</span>
                <span className="md__col md__col--size">{doc.size}</span>
              </div>
            ))}
          </div>
          <div className="md__statusbar">
            {DOCUMENTS.length} object(s)
            {selectedIdx >= 0 && ` | Selected: ${DOCUMENTS[selectedIdx].name}`}
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  font-family: Tahoma, sans-serif;
  font-size: 11px;

  .md__toolbar {
    background: linear-gradient(to right, #2955a5, #5b8dde);
    padding: 8px 12px;
    color: #fff;
  }
  .md__toolbar__title {
    font-size: 16px;
    font-weight: bold;
  }
  .md__toolbar__path {
    font-size: 10px;
    opacity: 0.8;
    margin-top: 2px;
  }

  .md__body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  .md__sidebar {
    width: 180px;
    background: #dfe8f6;
    border-right: 1px solid #7f9db9;
    padding: 8px;
    overflow-y: auto;
    flex-shrink: 0;
  }
  .md__sidebar__section {
    margin-bottom: 12px;
  }
  .md__sidebar__title {
    font-weight: bold;
    color: #003399;
    font-size: 11px;
    margin-bottom: 4px;
    border-bottom: 1px solid #7f9db9;
    padding-bottom: 2px;
  }
  .md__sidebar__link {
    color: #003399;
    cursor: pointer;
    padding: 2px 0;
    font-size: 11px;
    &:hover { text-decoration: underline; }
  }
  .md__sidebar__info {
    font-size: 10px;
    color: #333;
    line-height: 1.4;
  }

  .md__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .md__header__row {
    display: flex;
    background: linear-gradient(to bottom, #fff, #e8e8e8);
    border-bottom: 1px solid #999;
    font-weight: bold;
    color: #333;
  }
  .md__col {
    padding: 3px 8px;
    border-right: 1px solid #ddd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .md__col--name { flex: 2; min-width: 180px; display: flex; align-items: center; gap: 4px; }
  .md__col--type { flex: 1; min-width: 100px; }
  .md__col--size { width: 60px; text-align: right; }
  .md__file__icon { width: 16px; height: 16px; flex-shrink: 0; }

  .md__list {
    flex: 1;
    overflow-y: auto;
  }
  .md__item {
    display: flex;
    cursor: pointer;
    &:hover { background: #e8f0ff; }
    &--selected { background: #316ac5; color: #fff; }
  }
  .md__statusbar {
    background: linear-gradient(to bottom, #e8e8e8, #d4d4d4);
    padding: 3px 8px;
    font-size: 10px;
    border-top: 1px solid #aaa;
    color: #555;
  }
`;

export default MyDocuments;
